import type { Menu, MenuItem } from '~/types'

export const useMenu = (menu: MaybeRef<Menu.Model>) => {
  const menuItems = computed<MenuItem.Model[]>(() => unref(menu)?.menuItems || [])
  const hasItems = computed<boolean>(() => unref(menuItems).length > 0)

  return { menuItems, hasItems }
}
